import { render } from "./absen-bulan-input-final-remote.vue?vue&type=template&id=287f57c9"
import script from "./absen-bulan-input-final-remote.vue?vue&type=script&lang=js"
export * from "./absen-bulan-input-final-remote.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__